import { render, staticRenderFns } from "./TabelaAbaFinanceiro.vue?vue&type=template&id=47bc16e0&scoped=true&"
import script from "./TabelaAbaFinanceiro.vue?vue&type=script&lang=js&"
export * from "./TabelaAbaFinanceiro.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAbaFinanceiro.vue?vue&type=style&index=0&id=47bc16e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc16e0",
  null
  
)

export default component.exports